/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Owner_HeaderInputs */



/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Explorer_Search_Owner_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_owner_header = /** @type {((inputs?: Explorer_Search_Owner_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Owner_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Owner")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Owner")
	return /** @type {LocalizedString} */ ("Owner")
});